export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12054.e370aa85.jpg";